import { BuildingLeftMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Communiques = [
  {
    fileStoreId: "7637b66e-9c37-4644-a84f-ef303cfd3cc6",
    label: "DG(BLDG)'s Communique",
    date: "",
    subject:
      "Communique on clarification for applicability of Rules 26(2b) and Section 394",
  },
  {
    fileStoreId: "95b829e2-92d2-4822-af81-ec270bb000ee",
    label: "DG(BLDG)'s Communique",
    date: "09/11/2021",
    subject: "Regarding charges for mechanical car parling",
  },
  {
    fileStoreId: "f74127d6-64c0-48f3-9d83-b270571edbaa",
    label: "DG(BLDG)'s Communique",
    date: "07/09/2021",
    subject:
      "Forwarding MC circular 07 of 2019-20 regarding Encroachment of footpath",
  },
  {
    fileStoreId: "ebdf8392-6a3d-46a0-9d28-86e8861cf04c",
    label: "DG(BLDG)'s Communique",
    date: "25/02/2020",
    subject:
      "Forwarding amendment of bldg rules (baba care, projected balcony, 25.5 meter height in rule 142)",
  },
  {
    fileStoreId: "2b01ba01-9ae4-49af-a850-2aa83d72bfab",
    label: "DG(BLDG)'s Communique",
    date: "08/04/2019",
    subject: "Regarding email id of officers of building dept",
  },
  {
    fileStoreId: "acc637b6-803a-42b8-ab09-cbe84b46561e",
    label: "DG(BLDG)'s Communique",
    date: "01/02/2019",
    subject: "Regarding amended General undertaking in terms of rule 4(11)",
  },
  {
    fileStoreId: "626003cb-00d8-4743-97c5-c86a509ea4c5",
    label: "DG(BLDG)'s Communique",
    date: "15/12/2018",
    subject: "Regarding KMC (Second Amendment) Act 2018",
  },
  {
    fileStoreId: "1fa1788d-38fa-437a-a75f-c7f0c76a0a2d",
    label: "DG(BLDG)'s Communique",
    date: "22/06/2018",
    subject:
      "Forwarding amended of building rules (metro corridore from 500 m to 1000 meter)",
  },
  {
    fileStoreId: "251041bc-1255-4fab-a468-06c760af4638",
    label: "DG(BLDG)'s Communique",
    date: "11/05/2018",
    subject:
      "Forwarding MC note dated 11052018 regarding Assessment roall to be authenticated by the appropriate authority(24 month)",
  },
  {
    fileStoreId: "9efdf0cc-597b-44e0-add8-243d3994aadc",
    label: "DG(BLDG)'s Communique",
    date: "05/02/2018",
    subject: "Regarding amendment of Building Rules (GTE, Road width)",
  },
  {
    fileStoreId: "f91d9b54-2b3e-4323-b3ed-434b8392578e",
    label: "DG(BLDG)'s Communique",
    date: "15/09/2015",
    subject:
      "Forwarding MC circular 57 of 2015-16 dated 09/09/2015 regarding procedure of building sanction",
  },
  {
    fileStoreId: "88442dd4-501b-4337-892e-73395e386fec",
    label: "DG(BLDG)'s Communique",
    date: "07/08/2015",
    subject: "Regarding future road map for WB housing Board and Housing Dept",
  },
  {
    fileStoreId: "ba1902b1-5e93-4759-a946-78ad768ec961",
    label: "DG(BLDG)'s Communique",
    date: "07/08/2015",
    subject:
      "Forwarding Order of CMLO regarding presence of advocated befor Hon'ble Court",
  },
  {
    fileStoreId: "3840f99c-9817-4e50-8af7-58e5a715caa5",
    label: "DG(BLDG)'s Communique",
    date: "20/07/2015",
    subject:
      "Forwarding MC note dated 14072015 regarding Assessment roall to be authenticated by the appropriate authority",
  },
  {
    fileStoreId: "dd3502de-3b13-4d99-9862-67521835d598",
    label: "DG(BLDG)'s Communique",
    date: "07/07/2015",
    subject:
      "Forwarding Mpl. Sec circular 14 of 2015-16 dated 02/07/2015 regarding Ward Borough",
  },
  {
    fileStoreId: "1139dfca-4569-4b71-81bb-9a405d057dad",
    label: "DG(BLDG)'s Communique",
    date: "06/07/2015",
    subject:
      "Forwarding MC circular 29 of 2015-16 regarding mandatorily approval of the authority before demolition us 400(8) or 400(1)",
  },
  {
    fileStoreId: "a25ce2a1-543b-448c-bbaf-8e708bb4eb05",
    label: "DG(BLDG)'s Communique",
    date: "04/07/2015",
    subject:
      "Forwarding MC circular 34 of 2015-16 on deletion of the ward factory/godown/workshop from assessment record",
  },
  {
    fileStoreId: "daad8021-3b21-4acc-9a9e-5d58d0aaed48",
    label: "DG(BLDG)'s Communique",
    date: "04/03/2015",
    subject: "Regarding Additional FAR (0.25) as per WB Incentive Scheme, 2015",
  },
  {
    fileStoreId: "7d0ffbb2-c00f-43ae-9a4b-03e127683fa1",
    label: "DG(BLDG)'s Communique",
    date: "03/03/2015",
    subject:
      "Regarding Release of some plots in different mouzas (Br-XII) as per LR notification",
  },
  {
    fileStoreId: "edbf9f31-0cf5-4974-afb3-7505a18d6669",
    label: "DG(BLDG)'s Communique",
    date: "10/02/2015",
    subject:
      "Regarding amendment of bldg rules (Green bldg etc., 69A, metro corridore, 100% in 142)",
  },
  {
    fileStoreId: "6e30f416-c60f-4df6-9665-d455f37cb0de",
    label: "DG(BLDG)'s Communique",
    date: "21/01/2015",
    subject: "Forwarding Amendment of KMC Act, 2014",
  },
  {
    fileStoreId: "d39c11d6-826f-48d3-b0aa-662bdf8f0eea",
    label: "DG(BLDG)'s Communique",
    date: "07/11/2014",
    subject: "Regarding amendment of bldg rules",
  },
  {
    fileStoreId: "d2f2b887-cb63-48cf-93ee-a41dd01e73aa",
    label: "DG(BLDG)'s Communique",
    date: "29/10/2014",
    subject: "Regarding Shareing of KMDA Development Charges",
  },
];

const Building_Sanction_Communique = () => (
  <TableStructure
    title="Communique"
    heading={false}
    list={Communiques}
    columnNo={3}
    firstColumnName="Communique"
    leftMenuList={BuildingLeftMenuList}
    longMenuList={true}
  />
);

export default Building_Sanction_Communique;
